export default {
  getPermits: getPermits
}

const permitRule = {
  super: {
    USER_ADMIN_EDIT: true
  },
  admin: {
    USER_SCOPE_EDIT: true,
    USER_STATUS_EDIT: true
  },
  office: {
    ITEM_FORCE_CREATE: true,
    ITEM_FORCE_EDIT: true,
    ITEM_FORCE_DELETE: true,

    FOLDER_FORCE_CREATE: true,
    FOLDER_FORCE_EDIT: true,
    FOLDER_FORCE_DELETE: true,

    ITEM_PRICE_VIEW: true,
    ITEM_PRICE_EDIT: true,

    PROJECT_CREATE: true,
    PROJECT_EDIT: true,
    PROJECT_EXPORT: true,

    USER_VIEW: true,
    USER_INVITATION: true
    // USER_SCOPE_EDIT: true

  },
  worker: {
    ITEM_CREATE: true,
    ITEM_EDIT: true,
    ITEM_DELETE: true,

    FOLDER_CREATE: true,
    FOLDER_EDIT: true,
    FOLDER_DELETE: true
  },
  visitor: {
    ITEM_VIEW: true,
    FOLDER_VIEW: true,
    PROJECT_VIEW: true
  }
}
function getPermits (userScope) {
  let permits = {}

  // no break in switch by design, in order to make lower user scope has access of all higher scope
  /* eslint-disable no-fallthrough */
  switch (userScope) {
    case 0:
      Object.assign(permits, permitRule.super)
    case 1:
      Object.assign(permits, permitRule.admin)
    case 2:
      Object.assign(permits, permitRule.office)
    case 3:
      Object.assign(permits, permitRule.worker)
    case 4:
      Object.assign(permits, permitRule.visitor)
      break
    default:
      permits = null
  }
  return permits
}
